import { Product } from './product';
import { ChangedHistoryModel } from './changed-history';
import { PaymentHistoryModel } from './payment-history';
import { OrderComplainModel } from './order-complain';

export class Order {
    public id!: number;
    public orderCode!: string;
    public createdDate!: string;
    public deposit!: number;
    public depositRate!: number;
    public minDeposit!: number;
    public shopName!: string;
    public site!: string;
    public status!: number;
    public statusDetail!: any;
    public totalAmountVND!: number;
    public uId!: number;
    public imageOrigin!: string;
    public isChecked!: boolean;


    // Extands Detail
    public amountCNY!: number;
    public amountVND!: number;
    public buyerID!: number;
    public createdBy!: any;
    public transactionCodes!: string;
    public depositDate!: string;
    public boughtDate!: string;
    public shopDeliverDate!: string;
    public storeCNImDate!: string;
    public storeCNExDate!: string;
    public storeVNImDate!: string;
    public storeVNExDate!: string;
    public completedDate!: string;
    public exchangeRate!: number;
    public feeBuy!: number;
    public feeBuyAmount!: number;
    public feeBuyDiscount!: number;
    public feeOther!: number;
    public feeOtherNote!: string;
    public feeShipCN!: number;
    public feeShipCNVND!: number;
    public feeWeight!: number;
    public feeWeightAmount!: number;
    public feeWeightDiscount!: number;
    public guaranteeAmount!: number;
    public guaranteeAmountVND!: number;
    public isCheck!: boolean;
    public isFragileGoods!: boolean;
    public isFast!: boolean;
    public modifiedBy!: number;
    public modifiedDate!: string;
    public note!: string;
    public feeShipType!: number;
    public orderWeight!: number;
    public receivePlaceID!: number;
    public chinaStoreID!: number;
    public salerId!: number;
    public shopId!: number;
    public fragileFee!: number;
    public fragileFeeVND!: number;
    public checkFeeType!: number;
    public checkFee!: number;
    public checkFeeVND!: number;
    public fastFee!: number;
    public fastFeeVND!: number;
    public surcharge!: number;
    public totalRealAmount!: number;
    public totalRealAmountCNY!: number;
    public discountVND!: number;

    public products!: Product[];
    public changedHistories!: ChangedHistoryModel[];
    public paymentHistory!: PaymentHistoryModel[];
    public orderComplains!: OrderComplainModel[];
}
